import {http} from '../utils'
// 查询
const searchAction = (params) => {
  const url = `/market/manual/questionnaire/page`
  return http.post(url, params)
}
// 获取详情
const getAction = (id) => {
  const url = `/market/manual/questionnaire/detail/${id}`
  return http.post(url)
}
// 新增、编辑
const addAction = (params) => {
  const url = `/market/manual/questionnaire/save`
  return http.post(url, params)
}
// 删除
const deleteAction = (id) => {
  const url = `/market/manual/questionnaire/delete/${id}`
  return http.post(url)
}

export default {
  searchAction,
  getAction,
  addAction,
  deleteAction,
}
